import Vue from 'vue'
import App from './App.vue'

import api from '../js/api.js'
import common from '../js/common.js'
import  queryWrapper from '../js/queryWrapper.js'
import router from  '../router/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



Vue.use(ElementUI);
Vue.config.productionTip = false
//挂载请求对象
Vue.prototype.$api=api;
Vue.prototype.$common=common;
Vue.prototype.$queryWrapper=queryWrapper;
new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
